import component from './buy.component';
import routes from './buy.routes';
import paycellCardAddModule from './paycell-card-add/paycell-card-add.module';
import billInfoModule from './bill-info/bill-info-root.module';
import payByCardModule from './pay-by-card/pay-by-card.module';
import savedCardsModule from './saved-cards/saved-cards.module';
import noAuthModule from '../no-auth/no-auth.module';

import billInfoRootRoutes from './bill-info/bill-info-root.routes';
import payByBillModule from './pay-by-bill/pay-by-bill.module';
import paymentMethodModule from './payment-method/payment-method.module';
import paymentServicesModule from './services/payment-services.module';
import cardDeleteDialogComponent from './card-delete-dialog/card-delete-dialog.component';
import cancelSubscriptionDialogComponent from './cancel-subscription-dialog/cancel-subscription-dialog.component';
import cardDeleteSuccessDialogComponent from './card-delete-success-dialog/card-delete-success-dialog.component';
import buySuccessDialogComponent from './buy-success-dialog/buy-success-dialog.component';
import distantSalesAggreementDialogComponent from './distant-sales-aggreement-dialog/distant-sales-aggreement-dialog.component';
import preInfoFormDialogComponent from './pre-info-form-dialog/pre-info-form-dialog.component';
import paycellInfoDialogComponent from './paycell-info-dialog/paycell-info-dialog.component';
import cardAddContractDialogComponent from './card-add-contract-dialog/card-add-contract-dialog.component';
import contractsComponent from './contracts/contracts.component';
import changePaymentInfo from './change-payment-info-dialog/change-payment-info.component';
import changePaymentResult from './change-payment-result-dialog/change-payment-result.component';
import contractMobileComponent from './contract-mobile/contract-mobile.component';
import openMasterBuyDialogModule from '../family-plan/family-plan-master-buy-dialog/family-plan-master-buy-dialog.module';
import masterpassCardAddOtpDialogComponent from './masterpass-card-add-otp-dialog/masterpass-card-add-otp-dialog.component';
import masterpassCardLinkDialogComponent from './masterpass-card-link-dialog/masterpass-card-link-dialog.component';
import masterpassCardDeleteDialogComponent from './masterpass-card-delete-dialog/masterpass-card-delete-dialog.component';
import masterpassInfoDialogComponent from './masterpass-info-dialog/masterpass-info-dialog.component';
import churnRetentionDialogComponent from './churn-retention-dialog/churn-retention-dialog.component';

export default angular
  .module('fizyweb.paycell.buy', [
    paycellCardAddModule,
    payByCardModule,
    billInfoModule,
    payByBillModule,
    paymentServicesModule,
    paymentMethodModule,
    savedCardsModule,
    openMasterBuyDialogModule,
    noAuthModule
  ])
  .component('fizyPaycellBuy', component)
  .component('cardDeleteDialog', cardDeleteDialogComponent)
  .component('cardDeleteSuccessDialog', cardDeleteSuccessDialogComponent)
  .component('buySuccessDialog', buySuccessDialogComponent)
  .component('distantSalesAggreementDialog', distantSalesAggreementDialogComponent)
  .component('preInfoFormDialog', preInfoFormDialogComponent)
  .component('cardAddContractDialog', cardAddContractDialogComponent)
  .component('fizyPaycellContracts', contractsComponent)
  .component('fizyPaycellContractMobile', contractMobileComponent)
  .component('paycellInfoDialogComponent', paycellInfoDialogComponent)
  .component('cancelSubscriptionDialog', cancelSubscriptionDialogComponent)
  .component('changePaymentInfo', changePaymentInfo)
  .component('changePaymentResult', changePaymentResult)
  .component('masterpassCardAddOtpDialog', masterpassCardAddOtpDialogComponent)
  .component('masterpassCardLinkDialog', masterpassCardLinkDialogComponent)
  .component('masterpassCardDeleteDialog', masterpassCardDeleteDialogComponent)
  .component('masterpassInfoDialog', masterpassInfoDialogComponent)
  .component('churnRetentionDialog', churnRetentionDialogComponent)
  .config(routes)
  .config(billInfoRootRoutes).name;



// WEBPACK FOOTER //
// src/app/buy/buy.module.ts